import React from 'react';
import { PipelineState } from 'src/pages/Settings/components/WalkthroughBackupUploader/Hooks/useWalkthroughBackupUpload';
import './LoadingStep.scss';

interface LoadingStepProps {
  state: PipelineState;
  fileName: string;
}

const LOADING_COPY: Partial<
  Record<
    PipelineState,
    {
      heading: string;
      apiLabel: string;
      warning?: string;
    }
  >
> = {
  validating: {
    heading: 'Validating file...',
    apiLabel: 'Checking the file structure and extracting walkthrough details.',
  },
  'checking-status': {
    heading: 'Running pre-flight checks...',
    apiLabel: 'Verifying the walkthrough exists and is eligible for restore.',
  },
  'fetching-url': {
    heading: 'Preparing upload...',
    apiLabel: 'Securing a upload destination for your backup file.',
  },
  uploading: {
    heading: 'Uploading Walkthrough backup file...',
    apiLabel: 'Your file is being uploaded securely.',
    warning: 'This may take several minutes for large files. Please keep this tab open until complete.',
  },
};

export const LoadingStep = ({ state, fileName }: LoadingStepProps) => {
  const copy = LOADING_COPY[state];
  if (!copy) return null;

  return (
    <div className="ls_container">
      <div className="ls_spinner" />
      <p className="ls_heading">{copy.heading}</p>
      {fileName && (
        <div className="ls_file_chip">
          <span className="ls_file_icon">📄</span>
          {fileName}
        </div>
      )}
      <div className="ls_progress_bar">
        <div className="ls_progress_bar_fill" />
      </div>
      {copy.warning && <div className="ls_warning">{copy.warning}</div>}
      <p className="ls_api_label">{copy.apiLabel}</p>
    </div>
  );
};
